export var ContentTypes;
(function (ContentTypes) {
    ContentTypes["YOUTUBE"] = "YOUTUBE";
    ContentTypes["YOUTUBE_PLAYLIST"] = "YOUTUBE_PLAYLIST";
    ContentTypes["PICTURE"] = "PICTURE";
    ContentTypes["PDF"] = "PDF";
    ContentTypes["AUDIO"] = "AUDIO";
    ContentTypes["CODE"] = "CODE";
    ContentTypes["MARKDOWN"] = "MARKDOWN";
    ContentTypes["VIDEO"] = "VIDEO";
})(ContentTypes || (ContentTypes = {}));
export var LessonTypes;
(function (LessonTypes) {
    LessonTypes["YOUTUBE_ONLY"] = "YOUTUBE_ONLY";
    LessonTypes["TUTORIALS"] = "TUTORIALS";
})(LessonTypes || (LessonTypes = {}));
export var Languages;
(function (Languages) {
    Languages["css"] = "css";
    Languages["js"] = "js";
    Languages["html"] = "html";
    Languages["python"] = "python";
    Languages["go"] = "go";
    Languages["java"] = "java";
    Languages["kotlin"] = "kotlin";
    Languages["sql"] = "sql";
    Languages["rust"] = "rust";
    Languages["csharp"] = "csharp";
    Languages["typescript"] = "typescript";
    Languages["c"] = "c";
    Languages["dart"] = "dart";
    Languages["ruby"] = "ruby";
    Languages["lua"] = "lua";
    Languages["swift"] = "swift";
    Languages["r"] = "r";
    Languages["cpp"] = "cpp";
})(Languages || (Languages = {}));
